import { Box, BoxProps } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

const StyledBackButtonContainer = styled(Box)<BoxProps>`
  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    padding-right: ${({ theme }) => theme.spacing[400]};
    margin-right: ${({ theme }) => theme.spacing[400]};
    border-right: ${({ theme }) => theme.borderWidth[25]} solid
      ${({ theme }) => theme.color.border.base};
    padding-bottom: 0;
  }
`;

export { StyledBackButtonContainer };
